import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivityInternalWrapperComponent, GungModalService } from 'gung-standard';
import { CultActivityInternalListConfigService } from '../../services/cult-activity-internal-list-config.service';

@Component({
  selector: 'cult-activity-internal-wrapper',
  templateUrl: './cult-activity-internal-wrapper.component.html',
  styleUrls: ['./cult-activity-internal-wrapper.component.scss']
})
export class CultActivityInternalWrapperComponent extends ActivityInternalWrapperComponent implements OnInit {

  constructor(
    protected modalService: NgbModal, 
    protected gungModalService: GungModalService, 
    private route: ActivatedRoute, 
    public cultActivityInternalListConfigService: CultActivityInternalListConfigService ) {
    super(modalService, gungModalService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.route.params.subscribe(params => {
      this.cultActivityInternalListConfigService.activityType.next(params.type);
    });
  }
}
